(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teka-hero-video"] && !Shopify.designMode) return;
  try {
    
  function initializeTekaHeroVideos(root) {
    var videos = root.querySelectorAll('.teka-hero__video');

    videos.forEach(function(video) {
      if (video.dataset.tekaVideoInitialized === 'true') {
        return;
      }

      video.dataset.tekaVideoInitialized = 'true';

      var hero = video.closest('.teka-hero');

      if (!hero) {
        return;
      }

      function setVideoPlaying(isPlaying) {
        hero.classList.toggle('teka-hero--video-playing', isPlaying);
      }

      video.addEventListener('playing', function() {
        setVideoPlaying(true);
      });

      video.addEventListener('waiting', function() {
        setVideoPlaying(false);
      });

      video.addEventListener('stalled', function() {
        setVideoPlaying(false);
      });

      video.addEventListener('pause', function() {
        setVideoPlaying(false);
      });

      video.addEventListener('ended', function() {
        setVideoPlaying(false);
      });

      video.addEventListener('error', function() {
        setVideoPlaying(false);
      });

      video.addEventListener('emptied', function() {
        setVideoPlaying(false);
      });

      var isAlreadyPlaying =
        !video.paused &&
        !video.ended &&
        video.readyState >= 2 &&
        !video.error;

      setVideoPlaying(isAlreadyPlaying);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeTekaHeroVideos(document);
    });
  } else {
    initializeTekaHeroVideos(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeTekaHeroVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
